import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DataLibraryLayout } from '../../components/DataLibrary';
import classes from './DataLibraryPage.module.css';

export function DataLibraryPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const cohortParam = searchParams.get('cohort') ?? undefined;

  const handleCohortChange = useCallback(
    (cohortIds: string[]) => {
      setSearchParams(
        cohortIds.length > 0 ? { cohort: cohortIds.join(',') } : {},
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return (
    <div className={classes.page}>
      <DataLibraryLayout
        defaultCohortId={cohortParam}
        onCohortChange={handleCohortChange}
      />
    </div>
  );
}
